import { useCallback, useContext, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useWalletContext } from "../../context/WalletContext";
import { useSnackbar } from "../../context/SnackbarContext";
import { LanguageContext } from "../../context/LanguageContext";

// Opens Sell Vouchers only when backend has vouchers; otherwise shows "Coming soon"
const useSellVoucherNavigation = () => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const location = useLocation();
  const { walletData, fetchVochureList } = useWalletContext();
  const { showSnackbar } = useSnackbar();
  const isChecking = useRef(false);
  const [isSellVoucherLoading, setIsSellVoucherLoading] = useState(false);

  const goToSellVouchers = useCallback(
    async (navigateOptions) => {
      if (isChecking.current) return;
      let vouchers = walletData?.available_vouchers || [];
      if (vouchers.length === 0) {
        // walletData may not be loaded yet (direct link / refresh), so confirm with backend
        isChecking.current = true;
        setIsSellVoucherLoading(true);
        try {
          vouchers = (await fetchVochureList(navigate)) || [];
        } finally {
          isChecking.current = false;
          setIsSellVoucherLoading(false);
        }
      }
      if (vouchers.length === 0) {
        showSnackbar({ message: I18n.coming_soon, severity: "info"});
        return;
      }
      // `from` lets the Sell Vouchers guard return the user here if vouchers disappear
      navigate("/UCash/Vouchers", {
        ...navigateOptions,
        state: { ...navigateOptions?.state, from: location.pathname },
      });
    },
    [walletData, fetchVochureList, navigate, location.pathname, showSnackbar, I18n],
  );

  return { goToSellVouchers, isSellVoucherLoading };
};

export default useSellVoucherNavigation;
